export default __webpack_public_path__ + "static/partnerIcon15-2ae290400af3350c6acb6ec9b3fd72b4.svg";